<div v-bind:class="[tableClass, getClassName]">
    <template v-if="isQuantityTable && getIsStoreCodeStiegl">
        <div v-bind:class="getClassName + 'HeaderContainerQuantity'">
            <div v-bind:class="[getClassName + 'Header', getClassName + 'HeaderQuantity']">{{ $t(tableName) }}</div>
            <div v-bind:class="[getClassName + 'Header', getClassName + 'HeaderQuantity']">{{ $t('Price excluding Tax') }}</div>
        </div>
        <slot></slot>
    </template>
    <template v-else>
        <div v-bind:class="getClassName + 'Header'">{{ $t(tableName) }}</div>
        <slot></slot>
    </template>
</div>

